import { getSavedState, saveState } from '@utils/user-info.js'

export const state = {
    translationPageState: getSavedState('pages.translationPageState'),
    translationByDayStatPageState: getSavedState('pages.translationByDayStatPageState'),
}

export const mutations = {
    SET_TRANSLATION_PAGE_STATE(state, { translationPageState }) {
        state.translationPageState = translationPageState
        saveState('pages.translationPageState', translationPageState)
    },
    SET_TRANSLATION_BY_DAY_STAT_PAGE_STATE(state, { translationByDayStatPageState }) {
        state.translationByDayStatPageState = translationByDayStatPageState
        saveState('pages.translationByDayStatPageState', translationByDayStatPageState)
    },
}

export const getters = {
    translationPageState(state) {
        return state.translationPageState
    },
    translationByDayStatPageState(state) {
        return state.translationByDayStatPageState
    }
}

export const actions = {
    setTranslationPageState({ commit }, payload) {
        commit('SET_TRANSLATION_PAGE_STATE', payload)
    },
    setTranslationByDayStatPageState({ commit }, payload) {
        commit('SET_TRANSLATION_BY_DAY_STAT_PAGE_STATE', payload)
    }
}
